import type { ReactNode } from "react";

import CollapsibleListItem from "common/core/collapsible_list/item";
import Grid from "common/details/grid";

import Styles from "./index.module.scss";

type Props = {
  header: string;
  subheader: ReactNode;
  children: ReactNode;
  expandInitially?: boolean;
};

export function SignerDetailsWrapper({
  header,
  subheader,
  children,
  expandInitially = true,
}: Props) {
  return (
    <CollapsibleListItem header={header} subheader={subheader} initialDisplay={expandInitially}>
      <Grid className={Styles.noPaddingGrid}>{children}</Grid>
    </CollapsibleListItem>
  );
}
